module.exports = __webpack_public_path__ + "static/PhilosophyPagePerson-b1afa57b3876ff42047ccf2e5f3914af.svg";